export default __webpack_public_path__ + "static/media/product_bullet.01d5788b.svg";